angular.module('leave')
    .component('leaveBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/leave/_btn-options.html',
        controller: function ($rootScope, LeaveService, Principal, FilesSimpleUploadService, FilesLibrary) {
            this.LeaveService = LeaveService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.fileResourceName = 'LEAVE'

            this.$onChanges = () => {
                this.isManager = Principal.hasAnyAuthority(["ROLE_LEAVE_MANAGER"]);
                this.canCancel = this.isManager;
                this.canDelete = Principal.hasAnyAuthority(["ROLE_ADMIN"]);
                Principal.currentUser().then(user => {
                    this.canManageFiles = this.isManager || this.item.user.id === user.id || this.item.manager.id === user.id
                })
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('leave.updated'));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('leave.updated'));
        }
    })
